import { FunctionalComponent, h } from 'preact';

import { PropertyCardTemplatePropsInterface } from 'common/module/property/card/template-props.interface';
import { useListStatsTealiumImpressionsQueue } from 'common/module/property/list/stats/tealium/impressions-queue.hook';
import { PropertyListTemplatePropsInterface } from 'common/module/property/list/template-props.interface';
import { PropertyCardGetTemplate } from 'desktop/module/property/card/get-template';

/**
 * Get property card template
 */
const PropertyCardTemplate = PropertyCardGetTemplate();

export const PropertyListTemplate: FunctionalComponent<PropertyListTemplatePropsInterface> = (props) => {
  const onEnteringScreen = useListStatsTealiumImpressionsQueue();

  return (
    <div>
      {!props.properties.length && (
        <div className='no-result-found no-result-found--style2'>{props.noResultMessage}</div>
      )}
      {props.properties.length > 0 && (
        <ul className={`card-list ${props.disabled ? 'card-list--disabled' : ''}`}>
          {props.properties.map((item, index) => {
            const templateProps = { ...item, index } as PropertyCardTemplatePropsInterface;

            return (
              <li className='card-list__item'>
                <PropertyCardTemplate
                  {...templateProps}
                  isTargetBlank={props.isTargetBlank}
                  onComponentDidMount={(element: HTMLElement) => item.onCreateTemplate(element, index)}
                  onEnteringScreen={onEnteringScreen}
                />
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
